var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-date"},[_c('UIDatepicker',{attrs:{"locale":_vm.location.locale,"value":_vm.startTime,"options":{ time_24hr: _vm.location.twentyFourHourTime }},on:{"update":_vm.changeDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }